module.exports = __webpack_public_path__ + "img/VI.e94dd87b.svg";